import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CandidateService } from '../../candidate.service';
import {
    loadCandidateProfileComponents,
    loadCandidateProfileComponentsFailure,
    loadCandidateProfileComponentsSuccess,
    loadShouldDisplayCandidateProfileComponents,
    loadShouldDisplayCandidateProfileComponentsFailure,
    loadShouldDisplayCandidateProfileComponentsSuccess,
    verifyContactInfoComponents,
    verifyContactInfoComponentsFailure,
    verifyRTOComponent,
    verifyRTOComponentFailure
} from './profile-component.actions';
import { ProfileComponent } from './profile-component.state';
import { catchError, exhaustMap, map, of } from 'rxjs';

@Injectable()
export class ProfileComponentEffects {
    constructor(
        private readonly _actions$: Actions,
        private readonly _candidateService: CandidateService
    ) {}

    loadCandidateProfileComponents$ = createEffect(() =>
        this._actions$.pipe(
            ofType(loadCandidateProfileComponents),
            exhaustMap((action) => {
                return this._candidateService.getCandidateProfileComponents(action.candidateId).pipe(
                    map((result: ProfileComponent[]) =>
                        loadCandidateProfileComponentsSuccess({ profileComponents: result })
                    ),
                    catchError((error) => of(loadCandidateProfileComponentsFailure({ error })))
                );
            })
        )
    );

    loadShouldDisplayCandidateProfileComponents$ = createEffect(() =>
        this._actions$.pipe(
            ofType(loadShouldDisplayCandidateProfileComponents),
            exhaustMap((action) => {
                return this._candidateService.getShouldDisplayCandidateProfileComponents(action.candidateId).pipe(
                    map((result: boolean) =>
                        loadShouldDisplayCandidateProfileComponentsSuccess({ allowProfileComponentsView: result })
                    ),
                    catchError((error) => of(loadShouldDisplayCandidateProfileComponentsFailure({ error })))
                );
            })
        )
    );

    verifyContactInfoComponents$ = createEffect(() =>
        this._actions$.pipe(
            ofType(verifyContactInfoComponents),
            exhaustMap((action) => {
                return this._candidateService.verifyContactInfoComponents(action.verifyContactInfoRequest).pipe(
                    map((result: ProfileComponent[]) =>
                        loadCandidateProfileComponentsSuccess({ profileComponents: result })
                    ),
                    catchError((error) => of(verifyContactInfoComponentsFailure({ error })))
                );
            })
        )
    );

    verifyRTOComponents$ = createEffect(() =>
        this._actions$.pipe(
            ofType(verifyRTOComponent),
            exhaustMap((action) => {
                return this._candidateService.verifyRtoComponent(action.validateRTOComponentRequest).pipe(
                    map((result: ProfileComponent[]) =>
                        loadCandidateProfileComponentsSuccess({ profileComponents: result })
                    ),
                    catchError((error) => of(verifyRTOComponentFailure({ error })))
                );
            })
        )
    );
}
